/** @format */

import { Input } from "antd";
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";

import pdfIcon from "../../../icons/pdf.png";
import printIcon from "../../../icons/print.png";
import excelIcon from "../../../icons/excel.png";
import { ExcelPrint, Pdf } from "../../../components/functions/Print";

const tableHeaders = [
  [
    { rowSpan: 5, children: "№" },
    {
      colSpan: 11,
      children:
        "3 bo‘lim.  Iqtisodiyot tarmoqlarda maʼmuriy xududlar bo‘yicha foydalanilgan suv to‘g‘risida hisobot",
    },
  ],
  [
    {
      rowSpan: 4,
      children:
        "Respublika, irrigatsiya tizimlari havza boshqarmalari va viloyatlar",
    },
    { rowSpan: 4, children: "Satr raqami" },
    { rowSpan: 4, children: "Jami olingan suv miqdori" },
    { colSpan: 8, children: "Shu jumladan" },
  ],
  [
    { rowSpan: 3, children: "Sug‘orishga" },
    { rowSpan: 3, children: "Sanoat, kommunal va texnik ehtiyojlarga" },
    { colSpan: 6, children: "Shu jumladan" },
  ],
  [
    { colSpan: 2, children: "Energetika" },
    { rowSpan: 2, children: "Sanoat" },
    { rowSpan: 2, children: "Kommunal xo‘jaligi" },
    { rowSpan: 2, children: "Baliqchilik " },
    { rowSpan: 2, children: "Boshqalar " },
  ],
  [{ children: "Jami olingani" }, { children: "Qaytarilmasdan ishlatilgani" }],
];

const tableData = [
  ["1", "Respublikasi bo‘yicha jami"],
  ["2", "Shu jumladan: Zarfshan tashlama"],
  ["3", "JMK tranzitidan tashqari Arnasoy s.o."],
  ["4", "Amudaryo havzasi bo‘yicha jami"],
  ["5", "Shu jumladan: Zarfshan tashlama"],
  ["6", "Qoraqalpog‘iston Respublikasi Suv xo‘jaligi vazirligi "],
  ["7", "         Shu jumladan"],
  ["8", "         Qoraqalpog‘iston Respublikasi"],
  ["9", "         Chapqirg‘oq Amudaryo ITHB"],
  ["10", "         Xorazm viloyati"],
  ["11", "         Amu-Qashqadaryo ITHB "],
  ["12", "         Shu jumladan"],
  ["13", "         Qashqadaryo viloyati"],
  ["14", "         Shu jumladan Tolimarjonni to‘ldirish. in-shcha"],
  ["15", "         Amu-Buxoro ITHB"],
  ["16", "         Shu jumladan"],
].map(([num, name]) => [
  num,
  name,
  400,
  2.9,
  2.9,
  2.9,
  2.9,
  1296,
  2.9,
  2.9,
  1296,
  53,
]);

const Table23 = () => {
  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "Statistik hisobotlar",
  });

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
          />
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={generatePDF}>
              <img src={printIcon} alt='print' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf("tblData")} className='btn p-0'>
              <img src={pdfIcon} alt='pdf' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint("Statistik hisobotlar", "sheet 1", "tblData")
              }>
              <img src={excelIcon} alt='excel' />
            </button>
          </li>
        </ul>
      </div>

      <div className='table-responsive tableFixHead'>
        <div ref={componentPDF} style={{ width: "100%" }}>
          <table id='tblData' className='table table-bordered table-style'>
            <thead>
              {tableHeaders.map((row, i) => (
                <tr key={i}>
                  {row.map((cell, j) => {
                    const { children, ...rest } = cell;
                    return React.createElement(
                      "th",
                      { key: j, ...rest },
                      children
                    );
                  })}
                </tr>
              ))}
            </thead>

            <tbody>
              {tableData.map((row, i) => (
                <tr key={i}>
                  {row.map((cell, j) =>
                    j < 2 ? <th key={j}>{cell}</th> : <td key={j}>{cell}</td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Table23;
